import React from "react"
import { useRotation } from "../../animations/Rotate"
import CustomButton from "../../atoms/Button"
import { ArrowForwardIcon } from "../../icons"

export interface ToggleButtonProps {
  children: React.ReactNode
  value: boolean
  onChange?: (value: boolean) => void
}

const ToggleButton = ({ children, value, onChange }: ToggleButtonProps) => {
  return (
    <CustomButton
      variant="text"
      onClick={() => onChange?.(!value)}
      className="items-center"
    >
      {children}
      <ArrowForwardIcon
        className="ml-2"
        style={useRotation(!value, {
          degrees: 180,
        })}
      />
    </CustomButton>
  )
}

export default ToggleButton
